import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { analytics } from '@/common/analytics/analytics'

type Result = {
    location: ReturnType<typeof useLocation>
    ready: boolean
}

export function useOnboardingContainerLogic(): Result {
    const location = useLocation()
    const prevLocation = useRef<string>()

    useEffect(() => {
        if (prevLocation.current !== location.pathname) {
            analytics.page()
            prevLocation.current = location.pathname
        }
    }, [location.pathname])

    return {
        location,
        ready: true, // Future: can add onboarding-specific ready checks
    }
}
